import React from 'react';
import Profissional from '../../../components/Profissionais/Profissionais';
import ThaisaImg from '../../../assets/profissionais/_MG_4655.jpeg';

function Thaisa() {
  return (
    <Profissional 
      nome="Thaísa Viana"
      cargo="Terapeuta Ocupacional"
      imagem={ThaisaImg}
      descricao={
        <>
          <div className="profissional-descricao">
            <p>Sou Terapeuta Ocupacional formada pela Universidade de Sorocaba e possuo mais de cinco anos de prática profissional. 
            Sou apaixonada pelo meu trabalho, me encontrei no que eu faço e principalmente no trabalho com as crianças. Quem trabalha com criança precisa de algo que vai à frente da técnica e das ciências, que é o afeto! O afeto transforma e é capaz de melhorar qualquer situação. Eu recebo muitas trocas positivas que também mudam o meu ser.</p><br></br>

            <p>Me especializei no desenvolvimento infantil e desde que eu me formei atuo nessa área voltada para os Transtornos de Desenvolvimento e Aprendizagem.</p><br></br>

            <p>Tenho cursos de formação que potencializaram minha prática profissional, sou formada em Análise do Comportamento Aplicada para Autismo e Deficiência Intelectual (ABA), Seletividade Alimentar, Desenvolvimento Psicomotor na Infância e Introdução à área de Integração Sensorial.</p><br></br>

            <p>A Terapia Ocupacional atua para favorecer o desenvolvimento humano, promovendo saúde através da ocupação humana. Atuamos para favorecer a autonomia do sujeito e ajudá-lo a viver suas atividades significativas.</p>

            <p>Ou seja, quando a pessoa tem alguma limitação, seja física, cognitiva, social ou emocional que esteja a impedindo de realizar desde tarefas básicas do dia a dia, como higiene, sono, alimentação, e até  as mais complexas, como trabalhar, cuidar da casa, cuidar de outra pessoa, socializar etc, a T.O ajuda a diminuir os prejuízos e melhorar a qualidade de vida dessas pessoas.</p><br></br>

            <p>No desenvolvimento infantil a T.O trabalha com crianças que possuem dificuldades em sua rotina, na escola, ou que tenha algum atraso no desenvolvimento.
              Trabalhamos para favorecer suas habilidades motoras, emocionais, sensoriais, sociais, escolares e principalmente, o brincar.
            </p>
          </div>
        </>
      }
    />
  );
}

export default Thaisa;
